import React from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { Pagination } from "./Pagination";

export const TableBottom = (props) => {
  const { t } = useTranslation();
  const { tableInstance, totalElements, ...rest } = props;
  const { pageSize, pageIndex } = tableInstance.state;

  const count = totalElements ?? tableInstance.data.length;
  const from = pageSize * pageIndex + 1;
  const limit = pageSize * (pageIndex + 1);
  const to = limit <= count ? limit : count;

  return (
    <Flex
      w="100%"
      justify="space-between"
      align="center"
      px={{ md: "22px" }}
      direction={{ sm: "column", md: "row" }}
    >
      <Text fontSize="sm" color="gray.500" fontWeight="normal" mb={{ sm: "24px", md: "0px" }}>
        {tableInstance.rows.length === 0
          ? t("system.labels.no-items-found")
          : t("system.labels.showing-items-count", { from, to, count })}
      </Text>

      {count > 0 && <Pagination tableInstance={tableInstance} {...rest} />}
    </Flex>
  );
}